/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */


/**
 * Resolves the human an activity should be attributed to, or null when there isn't one.
 *
 * Four distinct situations all produce null, and collapsing them is deliberate: a
 * system-originated write, a userId whose User row is soft-deleted, a userId the viewer is not
 * permitted to resolve, and no userId at all. None of them should name an actor, and none of them
 * needs to be told apart, because the wording omits the same clause either way.
 *
 * This replaces the `?? 'StreamBank'` fallback that was inlined across the feed's description
 * components. That fallback did not mean "actor unknown" — it rendered as a positive claim that
 * StreamBank made the change. Around 125 activities in the production data reference soft-deleted
 * users and were being attributed that way, as is every Fulcrum-sync and import-origin row.
 *
 * Callers treat null as "no `by` clause", which under the punctuation rule also means the line
 * finishes its own sentence.
 */
export const resolveActivityActor = (event) => event?.Activity?.User?.name ?? null;
